export type EmailVerificationStatus = 'pending' | 'verified' | 'expired' | 'consumed';

export interface EmailVerificationResumeState {
  challengeId: string;
  email: string;
  customerSlug: string;
  expiresAt: string;
  status: EmailVerificationStatus;
}

const EMAIL_VERIFICATION_STORAGE_KEY = 'customer-setup-email-verification';
const VALID_STATUSES = new Set<EmailVerificationStatus>([
  'pending',
  'verified',
  'expired',
  'consumed',
]);

export const readEmailVerificationResume = (): EmailVerificationResumeState | null => {
  try {
    const raw = window.sessionStorage.getItem(EMAIL_VERIFICATION_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const value = JSON.parse(raw) as Partial<EmailVerificationResumeState>;
    if (
      typeof value.challengeId !== 'string'
      || !value.challengeId.trim()
      || typeof value.email !== 'string'
      || !value.email.includes('@')
      || typeof value.customerSlug !== 'string'
      || !value.customerSlug.trim()
      || typeof value.expiresAt !== 'string'
      || typeof value.status !== 'string'
      || !VALID_STATUSES.has(value.status as EmailVerificationStatus)
    ) {
      window.sessionStorage.removeItem(EMAIL_VERIFICATION_STORAGE_KEY);
      return null;
    }
    return value as EmailVerificationResumeState;
  } catch {
    window.sessionStorage.removeItem(EMAIL_VERIFICATION_STORAGE_KEY);
    return null;
  }
};

export const persistEmailVerificationResume = (value: EmailVerificationResumeState): void => {
  window.sessionStorage.setItem(EMAIL_VERIFICATION_STORAGE_KEY, JSON.stringify(value));
};

export const clearEmailVerificationResume = (): void => {
  window.sessionStorage.removeItem(EMAIL_VERIFICATION_STORAGE_KEY);
};
